import { inject, Injectable } from '@angular/core';
import {Utils} from '../utils/amplify-utils';
import { ModuleProgress } from '../amplify/data-resource';
import { ProgressReport } from '../utils/commonTypes';
import { AmplifyService } from './amplify.service';

const FIRST_ELEMENT = 1;

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  private amplifyService = inject(AmplifyService);
  private amplifyClient = this.amplifyService.getClient();

  // public async reportGroupModuleProgress(groupJourneyId:string, productId: string, moduleId: string, contentId: string, contentDisplayOrder: number):Promise<boolean> {
  //   return await this.reportModuleProgress(productId, moduleId, contentId, contentDisplayOrder, groupJourneyId);
  // }

  // public async reportIndividualModuleProgress(productId: string, moduleId: string, contentId: string, contentDisplayOrder: number):Promise<boolean> {
  //   return await this.reportModuleProgress(productId, moduleId, contentId, contentDisplayOrder);
  // }

  public async reportModuleProgress(userId:string,productId: string, moduleId: string, contentId: string, contentDisplayOrder: number, groupJourneyId:string|null|undefined):Promise<boolean> {

    const standalone = groupJourneyId?false:true;
    console.log('Progress report', standalone?'STANDALONE':'GROUP', 'module', moduleId, 'content', contentId, 'displayOrder', contentDisplayOrder);
    const progress = standalone?await this.getStandaloneModuleProgress(userId,moduleId):await this.getGroupJourneyModuleProgress(userId,moduleId, groupJourneyId!);

    if (!progress && contentDisplayOrder === FIRST_ELEMENT) {
      //Create record
      console.log('CREATE PROGRESS!');
      const createResponse = await this.amplifyClient.models.ModuleProgress.create({
    // @ts-ignore
    moduleId: moduleId,
    // @ts-ignore
    userId: userId,
    // @ts-ignore
    lastContentId: contentId,
    // @ts-ignore
    lastContentDisplayOrder: contentDisplayOrder,
    // @ts-ignore
    productId:productId,
    // @ts-ignore
    type: standalone?'STANDALONE':'GROUP',
    // @ts-ignore
    groupJourneyId:groupJourneyId??'standalone' //must be something because of the secondary index
      });
      const createdProgress = Utils.getDataFromResult(createResponse.data, createResponse.errors, 'ModuleProgress.create');
      if (!createdProgress) { throw Error('Progress not stored, null') };
      return true;      
    }else
    //However, if is a progress report for the subsequent element, update it.
    if (progress && Number(progress.lastContentDisplayOrder+1) === Number(contentDisplayOrder)) {
      console.log(`UPDATE PROGRESS => ${contentDisplayOrder}`);
      //Update only if the reported progress is beyond the last seen content
      const response = await this.amplifyClient.models.ModuleProgress.update({
        id: progress.id,
    // @ts-ignore
    moduleId: moduleId,
    // @ts-ignore
    userId: userId,
    // @ts-ignore
    lastContentId: contentId,
    // @ts-ignore
    lastContentDisplayOrder: contentDisplayOrder,
    // @ts-ignore
    productId: productId
      });
      const updatedProgress = Utils.getDataFromResult(response.data, response.errors, 'ModuleProgress.update');
      if (!updatedProgress) { throw Error('Progress not updated, null') };
      return true;
    }else{
      console.log('NO CHANGES!');
    }

    return false; //Not created nor updated
  }

  public async getStandaloneModuleProgress(userId:string,moduleId: string): Promise<ModuleProgress | null> {
    const response = await this.amplifyClient.models.ModuleProgress.listModuleProgressByUserIdAndModuleId(
    {
      userId: userId,
      moduleId: {eq:moduleId},
    });
    const progress = Utils.getDataFromResult(response.data, response.errors, 'ModuleProgress.get');
    const standaloneProgress = progress?.find(p=>p.type === 'STANDALONE');
    return standaloneProgress || null;
  }

  public async getGroupJourneyModuleProgress(userId:string,moduleId: string, groupJourneyId:string): Promise<ModuleProgress | null> {
    const response = await this.amplifyClient.models.ModuleProgress.listModuleProgressByUserIdAndGroupJourneyId(
    {
      userId: userId,
      groupJourneyId: {eq:groupJourneyId},
    });
    const progress = Utils.getDataFromResult(response.data, response.errors, 'ModuleProgress.get');
    const moduleProgress = progress?.find(p=>p.moduleId === moduleId);
    return moduleProgress || null;
  }  

  public async loadProgress(userId:string,productId: string,groupJourneyId:string|null|undefined): Promise<ProgressReport> {
    let progressList:ModuleProgress[] = [];
    if(groupJourneyId){
      //Journey progress
      const response = await this.amplifyClient.models.ModuleProgress.listModuleProgressByUserIdAndGroupJourneyId({
        userId:userId,
        groupJourneyId:{eq:groupJourneyId}
      });
      progressList = Utils.getDataFromResult(response.data, response.errors, 'ModuleProgress.listModuleProgressByUserIdAndGroupJourneyId');
    }else{
      //Standalone progress = 
      const response = await this.amplifyClient.models.ModuleProgress.listModuleProgressByUserIdAndProductId({
        userId:userId,
        productId:{eq:productId}
      });
      progressList = Utils.getDataFromResult(response.data, response.errors, 'ModuleProgress.listModuleProgressByUserIdAndProductId').filter(p=>p.type === 'STANDALONE');
    }
    
    const report = {
      standalone: groupJourneyId?false:true,
      groupId: groupJourneyId,
      modules: progressList.map(p=>{return {
        moduleId:p.moduleId,
        lastContentId:p.lastContentId,
        lastContentDisplayOrder:p.lastContentDisplayOrder
      }})
    } as ProgressReport;
    return report;
  }  

}
